import { IPersonalInfo, InputFieldConfig, IImportData } from '../../../../../types';
import { StudentState } from '../../../../../store/student/types';

export type Fields = Pick<IPersonalInfo, 'givenName' | 'middleName' | 'surname' | 'hasOtherNames' | 'otherNames'>;

export type Visible = Record<'givenName' | 'middleName' | 'surname' | 'hasOtherNames', boolean>;

type Mandatory = Record<'givenName' | 'middleName' | 'surname' | 'hasOtherNames', boolean>;

export function getPageStatus(
  config: StudentState['config'],
  fields: Fields,
  importData: IImportData,
): {
  complete: boolean;
  visible: Visible;
} {
  const { givenName, middleName, surname, hasOtherNames, otherNames } = fields;

  const {
    GivenName: givenNameConfig,
    MiddleName: middleNameConfig,
    FamilyName: surnameConfig,
    HasOtherNames: hasOtherNamesConfig,
  }: {
    GivenName: InputFieldConfig;
    MiddleName: InputFieldConfig;
    FamilyName: InputFieldConfig;
    HasOtherNames: InputFieldConfig;
  } = config.Checklist.PersonalInfo.Page1;

  const visible: Visible = {
    givenName: givenNameConfig?.visible ?? true,
    middleName: (middleNameConfig?.visible ?? true) && !!importData.otherName,
    surname: surnameConfig?.visible ?? true,
    hasOtherNames: hasOtherNamesConfig?.visible ?? true,
  };

  const mandatory: Mandatory = {
    givenName: givenNameConfig?.mandatory ?? true,
    middleName: middleNameConfig?.mandatory ?? true,
    surname: surnameConfig?.mandatory ?? true,
    hasOtherNames: hasOtherNamesConfig?.mandatory ?? true,
  };

  const allOtherNamesComplete = (amount: number): boolean => {
    let complete = hasOtherNames ? Number(otherNames?.length) > 0 : true;
    for (let i = 0; i < amount; i++) {
      complete =
        complete &&
        !!otherNames![i] &&
        (otherNames![i].surname !== '' || otherNames![i].givenName !== '') &&
        otherNames![i].reason !== '';
    }
    return complete;
  };

  // prettier-ignore
  const complete =
    (!visible.givenName || !mandatory.givenName || givenName !== '') &&
    (!visible.middleName || !mandatory.middleName || middleName !== '') &&
    (!visible.surname || !mandatory.surname || surname !== '') &&
    (!visible.hasOtherNames ||
      !mandatory.hasOtherNames ||
      hasOtherNames !== undefined) &&
    allOtherNamesComplete(Number(otherNames?.length));

  return {
    complete,
    visible,
  };
}
